<mat-card class="viewerholder">
  <div class="docheader">    
    <div class="name">
     {{formName}}
    </div>
    <div class="right_pannel">
      <div class="head">               
        <button mat-icon-button  color="primary" (click)="CloseHTMLData(CloseViewDocument)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>


  <div class="docdetail">     
  
    <div class="viewList">

      <!-- search bar -->
      <div class="search">
        <div class="search_input">
          <input type="text" class="search"  placeholder="Enter search keywords here"  [(ngModel)]="searchKeyword">              
        <button mat-icon-button *ngIf="searchKeyword"  (click)="clearSearchData()" class="clearSearch" color="basic" ><mat-icon>close</mat-icon></button>
        </div>

        <div class="datepicker">
          <input type="text" ngxDaterangepickerMd 
          placeholder="Select date range"
          [(ngModel)]="dateRange"
          (change)="selectedDateRange($event)"
          class="form-control"/>
          <button mat-icon-button color="basic" (click)="clearDateRange()" *ngIf="dateRange" ><mat-icon>close</mat-icon></button>
        </div>

        <button (click)="searchFormData()" class="go" >Go</button>

        <button *ngIf="datatable.length>0" class="godownload" (click)="downloadData()">Download</button>
        
        <button *ngIf="datatable.length>0" class="filterList" mat-icon-button (click)="applyFilter(customize)"
          matTooltipClass="tooltip" matTooltip="Filters">
          <mat-icon>filter_list</mat-icon>
         </button>

      </div>

      



    </div>

    <table class="table" style="overflow-y: scroll;max-height:600px;" *ngIf="!noRecordFound">
      <span *ngFor="let row of datatable; let i = index">
          <thead>
             <th class="col">{{row.columnName}}</th>
          </thead>

           <tr *ngFor="let rowdata of row.value;">
               
            <td>
              <ng-container *ngIf="row.type=='Signature'; else elseifInitials">
                <img *ngIf="rowdata.substring(0,5) == 'data:'" height="17px" src={{rowdata}}/>
                 <p *ngIf="rowdata=='-'">-</p>
                 <p *ngIf="rowdata.substring(0,5)!= 'data:' && rowdata!='-'">{{rowdata}}</p>          
              </ng-container>
  
              <ng-template #elseifInitials>
              <ng-container *ngIf="row.type=='Initials'; else elseifImage">
                <img *ngIf="rowdata.substring(0,5) == 'data:'" height="17px"   src={{rowdata}}/>
                 <p *ngIf="rowdata=='-'">-</p>
                 <p *ngIf="rowdata.substring(0,5)!= 'data:' && rowdata!='-'">{{rowdata}}</p>
              </ng-container>
              </ng-template>
             
  
              <ng-template #elseifImage>
                <ng-container *ngIf="row.type=='Image'; else elseifFile">
                  <img *ngIf="rowdata.substring(0,5) == 'data:'" height="17px"   src={{rowdata}}/>
                  <p *ngIf="rowdata=='-'">-</p>
                </ng-container>
                </ng-template>
  
                <ng-template #elseifFile>
                  <ng-container *ngIf="row.type=='File'; else elseRow">
                    <p *ngIf="rowdata.substring(0,5) == 'data:'" (click)="DownloadFile(rowdata,row)"> Download</p>
                    <p *ngIf="rowdata=='-'">-</p>
                  </ng-container>
                  </ng-template>
                                 
              <ng-template #elseRow><p>{{rowdata}}</p></ng-template>   
            </td> 
              
          </tr> 
    
        </span>
    </table>

    <div *ngIf="noRecordFound" class="noRecordFound">No Record Found</div>
    
  </div>
</mat-card>

<div class="overlay" (click)="CloseHTMLData(CloseViewDocument)"></div>

<ng-template #customize>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Select the columns you want to display in this list
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <mat-dialog-content class="mat-typography">

    <div class="allheaders">
      <div class="fixrow sep">
        <span>Column Headers</span>
        <span> Active Columns</span>
      </div>

      <ng-container *ngFor="let item of displayColumn;let i = index">        
        <div class="sep">
          <span>{{item.columnName}}</span>
          <span *ngIf="item.columnName=='Submited By'">
            <mat-slide-toggle color="primary" [checked]="true" [disabled]=true>
            </mat-slide-toggle>           
          </span>
          <span *ngIf="item.columnName!='Submited By'">
            <mat-slide-toggle color="primary" [checked]="item.isDisplay" (change)="changedToggle(item,$event)">
            </mat-slide-toggle>           
          </span>
        </div>
      </ng-container>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!SubmitColumnsButton" (click)="onSubmitColumns()">Save</button>
  </mat-dialog-actions>
</ng-template>